import React from "react";
import Logo from "../../logo.svg";
const IncomePrint = ({ children,t,settings,i18n }) => {
  return (
    <div style={{direction:i18n.dir()}}>
      {/* --- الهيدر (Header) --- */}
      <div className="row print-only align-items-center g-4 mb-4 small">
        {/* العمود الأول: العنوان */}
        <div className="col-4">
          {Boolean(settings?.head_invoice_address) && (
            <div className="d-flex align-items-center justify-content-start gap-2">
              {settings?.company_address || ""}
            </div>
          )}
        </div>

        {/* العمود الثاني: اسم الشركة */}
        <div className="col-4 text-center">
          {Boolean(settings?.head_company_name) && (
            <div className="text-sm-head fw-bold" style={{ fontSize: "18px" }}>
              {settings?.company_name || ""}
            </div>
          )}
        </div>

        {/* العمود الثالث: اللوجو */}
        <div className="col-4">
          {Boolean(settings?.head_company_logo || Logo) && (
            <div className="d-flex align-items-center justify-content-end gap-2">
              <img
                src={settings?.company_logo}
                alt="logo"
                style={{ width: "60px", height: "60px", objectFit: "contain" }}
              />
            </div>
          )}
        </div>

        {/* سطر الوقت والتاريخ */}
        <div className="col-4">
          <div className="d-flex align-items-center justify-content-start gap-2">
            <strong>{t("time")}:</strong> {new Date().toLocaleTimeString()}
          </div>
        </div>
        <div className="col-4 text-center">
          <h5 className="mb-0">{t("income_title")}</h5>
        </div>
        <div className="col-4">
          <div className="d-flex align-items-center justify-content-end gap-2">
            <strong>{t("date")}:</strong> {new Date().toLocaleDateString()}
          </div>
        </div>
      </div>

      {children}
      <div
        className="row g-4 print-only mb-4 mx-3 small border-top pt-3 text-end"
        style={{ marginTop: "10px" }}
      >
        {/* السطر الأول: هاتف، موقع، إيميل */}
        {Boolean(settings?.show_phone) && (
          <div className="col-4 d-flex align-items-center justify-content-start gap-2">
            <strong style={{ whiteSpace: "nowrap" }}>{t("phone")}:</strong>
            <span>{settings?.company_phone}</span>
          </div>
        )}

        {Boolean(settings?.foot_company_website) && (
          <div className="col-4 d-flex align-items-center justify-content-start gap-2">
            <strong style={{ whiteSpace: "nowrap" }}>{t("website")}:</strong>
            <span>{settings?.company_website}</span>
          </div>
        )}

        {Boolean(settings?.foot_company_email) && (
          <div className="col-4 d-flex align-items-center justify-content-start gap-2">
            <strong style={{ whiteSpace: "nowrap" }}>{t("email")}:</strong>
            <span>{settings?.company_email}</span>
          </div>
        )}

        {/* السطر الثاني: رقم ضريبي، سجل تجاري، الختم */}
        {/* 🟢 قمنا بإضافة mt-3 للـ col لعمل مسافة أسطر متساوية ونظيفة */}
        {Boolean(settings?.foot_tax_number) && (
          <div
            className="col-4 mt-3 d-flex align-items-center justify-content-start gap-2"
            style={{ minHeight: "50px" }}
          >
            <strong style={{ whiteSpace: "nowrap" }}>{t("tax_number")}:</strong>
            <span>{settings?.company_tax_number}</span>
          </div>
        )}

        {Boolean(settings?.foot_company_commercial) && (
          <div
            className="col-4 mt-3 d-flex align-items-center justify-content-start gap-2"
            style={{ minHeight: "50px" }}
          >
            <strong style={{ whiteSpace: "nowrap" }}>
              {t("commercial_number")}:
            </strong>
            <span>{settings?.company_commercial}</span>
          </div>
        )}

        {Boolean(settings?.foot_company_seal) && (
          <div
            className="col-4 mt-3 d-flex align-items-center justify-content-start gap-2"
            style={{ minHeight: "50px" }}
          >
            {/* 🟢 الـ align-items-center هنا مع تحديد minHeight متساوي جعل خط النصوص بالكامل في السطر الثاني يقع على استقامة واحدة مع التوسط العمودي للختم */}
            <strong style={{ whiteSpace: "nowrap" }}>
              {t("company_seal")}:
            </strong>
            <img
              src={settings.company_seal}
              alt="seal"
              style={{
                width: "50px",
                height: "50px",
                borderRadius: "50%",
                objectFit: "cover",
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default IncomePrint;
